import { apiClient } from './client'
import type { SearchResponse } from '@/types/search'

export const searchApi = {
  search: async (query: string, projectId?: string): Promise<SearchResponse> => {
    const params = new URLSearchParams({ q: query })
    if (projectId) params.append('projectId', projectId)
    const response = await apiClient.get<SearchResponse>(`/api/search?${params}`)
    return response.data
  },
}
